export function batSafe(text) {
    return String(text ?? '').replace(/[&|<>^%"\r\n]/g, '').trim();
}
export function batFileSlug(value) {
    return value.replace(/[^A-Za-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'device';
}
//# sourceMappingURL=bat-safe.js.map